import Cookies from "./cookies";

export const testLocalStorageSupport = () => {
  const test = "testing";
  try {
    localStorage.setItem(test, test);
    const received = localStorage.getItem(test);
    localStorage.removeItem(test);

    return received === test;
  } catch (e) {
    return false;
  }
};

const createLocalStorage = (key) => ({
    get: () => localStorage.getItem(key),
    set: (value) => localStorage.setItem(key, value),
    //listen: (receiver) => listeners.push({key, func: receiver})
  });


const createCookieStorage = (key) => ({
  get: () => Cookies.get(key),
  set: (value) => Cookies.set(key, value, 30),
});

const createStorage = (key) => {
  const lsSupported = testLocalStorageSupport();

  return lsSupported ? createLocalStorage(key) : createCookieStorage(key);
};

// const listeners = [];
// const storageEventListener = (event) => {
//   listeners.filter(i => i && i.key === event.key).map(l => l.func && l.func(event));
// };
// window.addEventListener('storage', storageEventListener);

const JsonStorage = (key) => {
  const storage = createStorage(key);

  return {
    get: () => {
      try{
        const val = storage.get();
        if(val) {
          return JSON.parse(val);
        }
      }catch(e) {
        console.warn(`failed to load json from storage`, e)
      }
      return undefined;
    },
    set: (value) => storage.set(JSON.stringify(value)),
    // listen: storage.listen
  }
};

export default JsonStorage;
